import { useReactiveVar } from "@apollo/client";
import { useCallback, useState, useRef } from "react";
import { BottomNavi } from "./bottom-navi";
import { Left } from "./left";
import { Right } from "./right";
import * as Styles from "~/components/blocks/layout/global-navi/common/common-style";
import { Skeleton } from "~/components/blocks/layout/global-navi/skeleton";
import { dmmServiceListDataVar } from "~/components/blocks/layout/store";
import { useFade } from "~/hooks/use-fade";
import { isBot } from "~/util/is-bot";

export const Mobile = () => {
  const searchButtonRef = useRef<HTMLButtonElement>(null);

  const dmmServiceListData = useReactiveVar(dmmServiceListDataVar);

  const [isShowDmmService, setIsShowDmmService] = useState(false);
  const [isShowSearch, setIsShowSearch] = useState(false);
  const { isDisplay: isVisibleSearch } = useFade(isShowSearch, 150);

  const onToggleSearch = () => setIsShowSearch((prev) => !prev);
  const onHideSearch = () => setIsShowSearch(false);
  const onCloseDmmService = useCallback(() => setIsShowDmmService(false), []);
  const onToggleDmmService = useCallback(() => setIsShowDmmService((prev) => !prev), []);

  const element = (
    <Styles.HeaderWrapper isShowSearch={isShowSearch}>
      <Left
        isShowSearch={isShowSearch}
        isShowDmmService={isShowDmmService}
        onToggleDmmService={onToggleDmmService}
        onHideSearch={onHideSearch}
        onCloseDmmService={onCloseDmmService}
      />
      <Right
        isShowDmmService={isShowDmmService}
        isVisibleSearch={isVisibleSearch}
        isShowSearch={isShowSearch}
        searchButtonRef={searchButtonRef}
        onToggleDmmService={onToggleDmmService}
        onToggleSearch={onToggleSearch}
        onHideSearch={onHideSearch}
      />
      <BottomNavi />
    </Styles.HeaderWrapper>
  );

  if (isBot()) return element;

  return dmmServiceListData.length !== 0 ? element : <Skeleton />;
};
